import { call, put, takeEvery } from "redux-saga/effects";
import {
  getNewsSuccess,
  getNewsFailed,
  getSourcesSuccess,
  getSourcesFailed,
  getGenresSuccess,
  getGenresFailed,
  getManualNewsSuccess,
  getManualNewsFailed,
} from ".";
import { serverIp } from "../../../utils";
import { getSourceGenresSuccess, getSourceGenresFailed } from ".";

export function* getNewsArticles({ payload }: any): any {
  // Build query parameters dynamically
  const queryParams = new URLSearchParams();
  const { token } = payload;

  if (payload?.sources?.length) {
    payload.sources.forEach((source) => queryParams.append("sources", source));
  }

  if (payload?.genres?.length) {
    payload.genres.forEach((genre) => queryParams.append("genres", genre));
  }

  if (payload?.search) queryParams.append("search", payload.search);
  if (payload?.date) {
    // Handle date format: if it's YYYY-MM-DD, create date at midnight UTC for that date
    // This ensures the selected date is preserved regardless of user's timezone
    let isoDate;
    if (
      typeof payload.date === "string" &&
      payload.date.match(/^\d{4}-\d{2}-\d{2}$/)
    ) {
      // Date is in YYYY-MM-DD format, create at midnight UTC to preserve the selected date
      // This ensures Nov 11 stays Nov 11 in UTC, not shifted to Nov 10
      isoDate = payload.date + "T00:00:00.000Z";
    } else {
      // Date is already an ISO string or Date object, use as is
      isoDate = new Date(payload.date).toISOString();
    }
    queryParams.append("datetime", isoDate);
  }
  if (payload?.maxarticles)
    queryParams.append("maxArticles", payload.maxarticles);

  const requestUrl = `${serverIp}/get_news?${queryParams.toString()}`;

  try {
    const data = yield call(() =>
      fetch(requestUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    );

    const parsedData = yield data.json();
    yield put(getNewsSuccess(parsedData));
  } catch (err) {
    yield put(getNewsFailed());
  }
}

export function* getNewsSources(): any {
  const requestUrl = `https://gxkk3yzxg3rgaykek37gjccxgi0apfgr.lambda-url.eu-north-1.on.aws/sources`;
  try {
    // Send JSON data in the request body
    const data = yield call(() =>
      fetch(requestUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }),
    );

    const parsedData = yield data.json();
    yield put(getSourcesSuccess(parsedData));
  } catch (err) {
    yield put(getSourcesFailed());
  }
}
export function* getNewsGenres(): any {
  const requestUrl = `https://f3kcvlxi24vbfiixm7rhlzbgja0yzfjb.lambda-url.eu-north-1.on.aws/reuters/genres/`;

  try {
    const data = yield call(() =>
      fetch(requestUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }),
    );

    const parsedData = yield data.json();
    const topLevelKeys = Object.keys(parsedData);
    yield put(getGenresSuccess(topLevelKeys));
  } catch (err) {
    yield put(getGenresFailed());
  }
}

export function* fetchSourceGenres(): any {
  const requestUrl = `https://medianestrss.smartdemo.live/sources_with_genres`;

  try {
    const data = yield call(() =>
      fetch(requestUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }),
    );

    const parsedData = yield data.json();
    yield put(getSourceGenresSuccess(parsedData));
  } catch (err) {
    yield put(getSourceGenresFailed());
  }
}

export function* getManualNewsArticles({ payload }: any): any {
  // Build query parameters dynamically
  const queryParams = new URLSearchParams();
  const { token } = payload;

  // Note: get_manual_news API does not support 'sources' parameter
  // Only supports: search, genres, datetime, maxArticles

  if (payload?.genres?.length) {
    payload.genres.forEach((genre) => queryParams.append("genres", genre));
  }

  if (payload?.search) queryParams.append("search", payload.search);
  if (payload?.date) {
    // Handle date format: if it's YYYY-MM-DD, create date at midnight UTC for that date
    // This ensures the selected date is preserved regardless of user's timezone
    let isoDate;
    if (
      typeof payload.date === "string" &&
      payload.date.match(/^\d{4}-\d{2}-\d{2}$/)
    ) {
      // Date is in YYYY-MM-DD format, create at midnight UTC to preserve the selected date
      // This ensures Nov 11 stays Nov 11 in UTC, not shifted to Nov 10
      isoDate = payload.date + "T00:00:00.000Z";
    } else {
      // Date is already an ISO string or Date object, use as is
      isoDate = new Date(payload.date).toISOString();
    }
    queryParams.append("datetime", isoDate);
  }
  if (payload?.maxarticles)
    queryParams.append("maxArticles", payload.maxarticles);

  const requestUrl = `${serverIp}/get_manual_news?${queryParams.toString()}`;

  try {
    const data = yield call(() =>
      fetch(requestUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    );

    const parsedData = yield data.json();
    // Extract the 'news' array from the response object { count, news }
    const newsArray = parsedData.news || parsedData;
    yield put(getManualNewsSuccess(newsArray));
  } catch (err) {
    yield put(getManualNewsFailed());
  }
}

function* newsSaga() {
  yield takeEvery("news/getSourceGenres", fetchSourceGenres);
  yield takeEvery("news/getNews", getNewsArticles);
  yield takeEvery("news/getManualNews", getManualNewsArticles);
  yield takeEvery("news/getSources", getNewsSources);
  yield takeEvery("news/getGenres", getNewsGenres);
}

export default newsSaga;

// import { call, put, takeEvery } from "redux-saga/effects";
// import { getNewsSuccess, getNewsFailed } from ".";
// import { dummyNews } from "../../../dummyvalues";

// export function* getNewsArticles({ payload }: any): any {
//   // Build query parameters dynamically
//   const queryParams = new URLSearchParams();

//   if (payload?.sources?.length) {
//     payload.sources.forEach((source) => queryParams.append("sources", source));
//   }

//   if (payload?.genres?.length) {
//     payload.genres.forEach((genre) => queryParams.append("genres", genre));
//   }

//   if (payload?.search) queryParams.append("search", payload.search);
//   if (payload?.date) {
//     const isoDate = new Date(payload.date).toISOString();
//     queryParams.append("datetime", isoDate);
//   }
//   if (payload?.maxarticles)
//     queryParams.append("maxArticles", payload.maxarticles);

//   // const requestUrl = `http://127.0.0.1:8000/get_news?${queryParams.toString()}`;

//   try {
//     // Send JSON data in the request body
//     // const data = yield call(() =>
//     //   fetch(requestUrl, {
//     //     method: 'GET',
//     //     headers: {
//     //       'Content-Type': 'application/json',
//     //     },
//     //   })
//     // );

//     // const parsedData = yield data.json();
//     yield put(getNewsSuccess(dummyNews));
//   } catch (err) {
//     yield put(getNewsFailed());
//   }
// }

// function* newsSaga() {
//   yield takeEvery("news/getNews", getNewsArticles);
// }

// export default newsSaga;
